import { render } from "./about-details.vue?vue&type=template&id=f0621fe8&scoped=true"
import script from "./about-details.vue?vue&type=script&lang=js"
export * from "./about-details.vue?vue&type=script&lang=js"

import "./about-details.vue?vue&type=style&index=0&id=f0621fe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0621fe8"]])

export default __exports__